import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import Slider from "react-slick";

const ArrowButton = ({ direction, onClick, className }) => {
    const positionClass = direction === "left" ? "-left-2.5" : "-right-2.5";

    return (
        <button
            type="button"
            aria-label={direction === "left" ? "Previous Image" : "Next Image"}
            onClick={onClick}
            className={`swiper-gallery-arrow w-5 h-5 rounded-1/2 before:none ${positionClass} ${className}`}
        >
            {direction === "left" ? "<" : ">"}
        </button>
    );
};

const ImageGallery = (
    {
        slideshow,
        thumbnails,
        thumbsSlider, 
        slideshowSlider,
        setSlideshowSlider, 
        setThumbsSlider, 
        slideTo,
        galleryContainerStyle,
        initialSlide,
        onAfterSlideChange,
        imageAlt,
        isVariantImage,
        WarrantyBadge,
    },
) => {
    const slideshowSettings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 375,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        initialSlide,
        prevArrow: <ArrowButton direction="left" />,
        nextArrow: <ArrowButton direction="right" />,
        responsive: [
            {
                breakpoint: 990,
                settings: { arrows: true },
            },
        ],
        afterChange: (params) => {
            onAfterSlideChange(params);
        },
    };
    
    const gallerySettings = {
        dots: false,
        arrows: true,
        speed: 375,
        infinite: true,
        slidesToShow: thumbnails?.length <= 7 ? thumbnails.length : 7,
        slidesToScroll: 1,
        initialSlide,
        prevArrow: <ArrowButton direction="left" />,
        nextArrow: <ArrowButton direction="right" />,
        responsive: [
            {
                breakpoint: 1200,
                settings: { slidesToShow: thumbnails?.length <= 5 ? thumbnails?.length : 5 },
            },
        ],
    };

    const altText = (index) => `${imageAlt ? `${imageAlt} - ${index}` : `SealSkin Covers Main Slideshow - ${index}`}`;

    return (
        <div className={`lg:max-w-xl lg:pr-4 w-full ${galleryContainerStyle}`}>
            <Slider
                className="image-gallery-slideshow"
                asNavFor={thumbsSlider}
                ref={(slider1) => setSlideshowSlider(slider1)}
                {...slideshowSettings}
            >
                {slideshow?.map((image, index) => (
                    <div key={image?.node?.url} className="image-gallery-slideshow__item">
                        {WarrantyBadge && isVariantImage(image?.node) && WarrantyBadge() ? (
                            <WarrantyBadge className="image-gallery-slideshow__item-badge" />
                        ) : null}
                        <img
                            className="image-gallery-slideshow__item-image"
                            alt={altText(index)}
                            src={image?.node?.url}
                        />
                    </div>
                ))}
            </Slider>
            <Slider
                className="image-gallery-thumbnails py-2"
                asNavFor={slideshowSlider}
                ref={(slider2) => setThumbsSlider(slider2)}
                {...gallerySettings}
            >
                {thumbnails?.map((image, index) => (
                    <button 
                        type="button"
                        className="mr-4"
                        key={image.node.url}
                        onClick={() => slideTo(index)}
                    >
                        <img alt={altText(index)} src={image.node.url} className="w-full h-full object-contain mx-auto" />
                    </button>
                ))}
            </Slider>
        </div>
    );
};

export default ImageGallery;
